import { defineStore } from "pinia";
import { ref } from "vue";

export const useViewControlsStore = defineStore(
    "viewControls",
    () => {
        const viewControls = ref({
            disabled: true,
        });

        return {
            viewControls,
        };
    },
    {
        persist: true,
    }
);
